import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

const CloseButton = (props: HTMLAttributes<SVGSVGElement>) => (
    <CloseSVG width='22' height='22' viewBox='0 0 22 22' fill='none' {...props}>
        <line
            x1='6'
            y1='6'
            x2='16'
            y2='16'
            stroke='currentColor'
            strokeWidth='1'
            strokeLinecap='round'
        />
        <line
            x1='6'
            y1='16'
            x2='16'
            y2='6'
            stroke='currentColor'
            strokeWidth='1'
            strokeLinecap='round'
        />
    </CloseSVG>
);

const CloseSVG = styled.svg`
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
`;

export default CloseButton;
